import React, { useEffect, useState } from "react";
import { useLazyGetFormQuery } from "../redux/formService";
import { useLazyGetParamByTypeQuery } from "../redux/paramService";
import Form from "./Form";

const Modal = ({
  showForm,
  toSelect,
  setShowForm,
  fields,
  send,
  toSelect2,
  setRedevances,
  selectedData,
  selectType,
}) => {
  const [selected, setSelected] = useState(null);
  const [selected2, setSelected2] = useState(null);
  const [tarification, setTarification] = useState(null);
  const [fieldsTarif, setFieldsTarif] = useState(null);
  const [getForm, { data: formFields }] = useLazyGetFormQuery();
  const [originalFields, setOriginalFields] = useState();

  const [getParamsbyType, { data: paramsData, isFetching }] =
    useLazyGetParamByTypeQuery();

  useEffect(() => {
    setOriginalFields(fields);
  }, [fields]);

  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    const type =
      selected && isValidJSON(selected) ? JSON.parse(selected) : undefined;

    console.log("type", type);
    const fetchForms = async () => {
      if (type?.form && type?.form != 17) {
        const response = await getForm(type?.form);

        setFieldsTarif(response?.data?.data || null);
      } else {
        setFieldsTarif(null);
      }
    };
    fetchForms();
  }, [selected, getParamsbyType, setRedevances]);

  console.log("fieldsTarif", fieldsTarif);

  if (fieldsTarif) {
    let otherFields;
    if (fieldsTarif.attributes.name.includes("Commerces, banques, infra")) {
      otherFields = [fieldsTarif.attributes.fields.data[0]];
    } else {
      otherFields = fieldsTarif.attributes.fields.data;
    }

    // Récupérer les champs supplémentaires

    // Vérifiez si `fields` et `otherFields` sont des tableaux
    if (Array.isArray(fields) && Array.isArray(otherFields)) {
      fields = [...fields, ...otherFields]; // Fusionner les tableaux
    } else if (typeof fields === "object" && typeof otherFields === "object") {
      fields = { ...fields, ...otherFields }; // Fusionner les objets
    } else {
      console.warn(
        "Les types de `fields` et `otherFields` ne correspondent pas."
      );
    }
  }

  return (
    <div
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className={`${
        showForm ? "" : "hidden"
      } overflow-y-auto overflow-x-hidden flex fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full bg-black/50`}>
      <div className="relative p-4 w-full max-w-6xl max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
              Formulaire de création
            </h3>
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              onClick={() => setShowForm(!showForm)}>
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          <div className="flex flex-col justify-center items-center">
            {toSelect && !selectedData && (
              <select
                onChange={(e) => setSelected(e.target.value)}
                name="selection"
                className="capitalize ml-2 font-semibold border-solid rounded-3xl border-2 border-blue-600"
                id="select">
                <option value={undefined}>
                  Choisissez un type de redevance
                </option>
                {toSelect.map(
                  (item, index) =>
                    item?.label && (
                      <option key={index} value={JSON.stringify(item?.value)}>
                        {item?.label}
                      </option>
                    )
                )}
              </select>
            )}
          </div>

          {/* <div className="flex flex-col justify-center items-center mt-4">
            <select
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (selectedValue) {
                  setSelected(JSON.parse(selectedValue));
                } else {
                  setSelected({});
                }
              }}
              name="selection"
              className="capitalize ml-2 font-semibold border-solid rounded-3xl border-2 border-blue-600"
              id="select">
              <option value="">Choix du bureau</option>
              {[
                "Bamako",
                "Kayes",
                "Sikasso",
                "Mopti",
                "Segou",
                "Gao",
                "Kidal",
              ].map((item, index) => {
                if (item) {
                  return (
                    <option key={index} value={JSON.stringify(item)}>
                      {item}
                    </option>
                  );
                }
                return null; // Ignore les éléments sans label ou value
              })}
            </select>
          </div> */}

          <div className="p-4 md:p-5 space-y-4">
            <Form
              send={send}
              fields={fields}
              showForm={showForm}
              setShowForm={setShowForm}
              selectedData={selectedData}
              selected={selected}
              selected2={selected2}
              selectType={selectType}
              fieldsTarif={fieldsTarif}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
